import { Select, Space, Typography } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

import { MASS_OFFERINGS_PAYMENT_TYPES } from '../../constants';

const descriptions = {
  [MASS_OFFERINGS_PAYMENT_TYPES.online]: () => (
    <Typography.Text italic type="secondary">
      <small>ofiarę przekażesz szybką płatnością online</small>
    </Typography.Text>
  ),
  [MASS_OFFERINGS_PAYMENT_TYPES.toBeChosen]: reservationTimeInDays => (
    <Typography.Text italic type="secondary">
      <small>
        kancelaria potwierdzi rezerwację w&nbsp;ciągu {reservationTimeInDays} dni, ofiarę przekażesz
        później w&nbsp;dowolnej formie
      </small>
    </Typography.Text>
  ),
};

const dayInMs = 1000 * 60 * 60 * 24;

const ChoosePaymentType = ({
  control,
  inputFieldName,
  massDate, // in format '2024-06-04T05:30:00+0000'
  minDaysBefore,
  reservationTimeInDays,
}) => {
  const today = new Date();
  const massDateTime = new Date(massDate);
  const diffTime = Math.abs(massDateTime - today);
  const diffDays = Math.ceil(diffTime / dayInMs);
  const canPayLater = diffDays > minDaysBefore;

  return (
    <Controller
      control={control}
      name={inputFieldName}
      render={({ field }) => (
        <Space direction="vertical" className="w-100">
          <Select
            className="w-100"
            onChange={newValue => field.onChange(newValue)}
            value={field.value}
            options={[
              {
                value: MASS_OFFERINGS_PAYMENT_TYPES.online,
                label: 'Natychmiastowa gwarancja terminu',
              },
              canPayLater
                ? {
                    value: MASS_OFFERINGS_PAYMENT_TYPES.toBeChosen,
                    label: 'Wstępna rezerwacja terminu',
                  }
                : {
                    value: MASS_OFFERINGS_PAYMENT_TYPES.toBeChosen,
                    label: (
                      <div>
                        <div>Wstępna rezerwacja terminu</div>
                        <div>(opcja dostępna co najmniej {minDaysBefore} dni przed terminem)</div>
                      </div>
                    ),
                    disabled: true,
                  },
            ]}
          />

          {descriptions[field.value](reservationTimeInDays)}
        </Space>
      )}
    />
  );
};

ChoosePaymentType.propTypes = {
  control: PropTypes.object.isRequired,
  inputFieldName: PropTypes.string.isRequired,
  reservationTimeInDays: PropTypes.string.isRequired,
  minDaysBefore: PropTypes.number.isRequired,
  massDate: PropTypes.string.isRequired,
};

export default ChoosePaymentType;
